import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';

const unfilteredMainBankOptions = (
  [
    {
      value: null,
    },
    {
      value: 'Aktia',
    },
    {
      value: 'Danske',
    },
    {
      value: 'Handelsbanken',
    },
    {
      value: 'Hypoteekkiyhdistys',
    },
    {
      value: 'Nordea',
    },
    {
      value: 'Oma säästöpankki',
    },
    {
      value: 'Osuuspankki',
    },
    {
      value: 'POP-Pankki',
    },
    {
      value: 'S-Pankki Oy',
    },
    {
      value: 'Säästöpankki',
    },
    {
      value: 'Ålandsbanken',
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    string | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useMainBankOptions = () =>
  useApplicationConditionalFilter(unfilteredMainBankOptions);
